<template>
  <div class="iBusiness-wrapper">
    <!-- 1.顶部标题 -->
    <el-row>
      <h3 class="title">
        <div class="block">
          <span><span @click="goBack()" style="cursor: pointer">访客黑名单</span>>会话记录</span>
        </div>
      </h3>
    </el-row>
    <div class="chat-wrapper session-detail">
      <div class="chat-content">
        <div class="chat-block">
          <div class="chat-box" style="min-height: 670px; overflow-x: visible">
            <div class="chat-news" ref="chatNews">
              <div
                v-for="(item, index) in list"
                :key="index"
                :class="item.d === 'up' ? 'questioner' : 'answerer'"
                class="block"
              >
                <p class="inform">
                  <template v-if="item.d === 'up'">
                    <span class="username">{{ item.uname ? item.uname : '客户' }}</span>
                    <span>{{ item.t }}</span>
                  </template>
                  <template v-else>
                    <span>{{ item.t }}</span>
                    <span class="username">{{ item.agent.name ? item.agent.name : '客服' }}</span>
                  </template>
                </p>
                <div class="news-wrap">
                  <template v-if="item.d === 'up'">
                    <div class="news-avator">
                      <svg class="icon" aria-hidden="true">
                        <use
                          :xlink:href="'#icon' + (item.d === 'up' ? 'user-head' : 'kefu-head')"
                        />
                      </svg>
                    </div>
                    <div class="news" v-viewer>
                      <p v-html="translateMessage(item.type, item.msg)" />
                    </div>
                  </template>
                  <template v-else>
                    <div class="news" v-viewer>
                      <p v-html="translateMessage(item.type, item.msg)" />
                    </div>
                    <div class="news-avator">
                      <svg class="icon" aria-hidden="true">
                        <use
                          :xlink:href="'#icon' + (item.d === 'up' ? 'user-head' : 'kefu-head')"
                        />
                      </svg>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'ChatHistory',
  data() {
    return {
      list: [],
      limit: 50,
      page: 0,
      loading: false,
      islast: true,
      userInfo: {
        nameCn: '',
        level: '',
        phone: '',
        email: ''
      },
      resourceDownloadPath:
        window.$envUtils('VUE_APP_BASE_URL') +
        window.$envUtils('VUE_APP_WB_SERVICE') + '/res/download'
    }
  },
  mounted() {
    this.getList(0)
    this.$refs.chatNews.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    this.$refs.chatNews.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState(['emojis']),
    storeSessionId() {
      return this.$store.state.user.chatHistoryQuery.sessionId
    }
  },
  methods: {
    handleScroll() {
      if (!this.loading && !this.islast) {
        // 滚动到页面底部时
        const scrollTop = this.$refs.chatNews.scrollTop
        const clientHeight = this.$refs.chatNews.clientHeight
        const scrollHeight = this.$refs.chatNews.scrollHeight
        const toBottom = scrollHeight - clientHeight - scrollTop
        if (toBottom <= 100) {
          this.loading = true
          this.page++
          this.getList(this.page)
        }
      }
    },
    getList(_page) {
      const params = {
        sessionId: this.storeSessionId,
        page: _page,
        limit: this.limit
      }
      this.$http.get(window.$envUtils('VUE_APP_WB_SERVICE') + '/chathistory/list', { params })
        .then((res) => {
          this.list = this.list.concat(res.data.data)
          if (res.data.data.length < 50) {
            this.islast = true
          } else {
            this.islast = false
          }
          this.loading = false
        })
    },
    translateMessage(type, body) {
      if (type === 'image') {
        return '<img style="max-width:150px" src="' + this.resourceDownloadPath + body.url + '"/>'
      } else if (type === 'file') {
        return (
          '<div style="min-width:200px;float:left"><img style="max-width:60px;float:left" src="./static/image/file.png"><a target="hide_iframe" href="' +
          this.resourceDownloadPath +
          body.url +
          '"><div style="margin-top:8px;padding-top:5px;text-decoration:underline;color:black;">' +
          (body.name.length > 15 ? body.name.substring(0, 15) + '...' : body.name) +
          '</div></a><div style="color:black">大小：' +
          body.size +
          '</div></div>'
        )
      } else if (type === 'video') {
        return (
          '<div><video style="width:100%" controls="controls" src="' +
          this.resourceDownloadPath +
          body.url +
          '"></video></div>'
        )
      } else if (type === 'text') {
        body.content = body.content.replace('\n', '<br />')
        if (
          /\[.*?\]/g.test(body.content) ||
          /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g.test(
            body.content
          )
        ) {
          var emojis = this.emojis.emojis
          for (let i = 0; i < emojis.length; i++) {
            body.content = body.content.replace(
              emojis[i].reg,
              '<img src="./static/emoji/' +
                emojis[i].file +
                '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />'
            )
          }
        }
        return body.content
      } else if (type === 'voice') {
        return (
          body.recognition +
          '</br><audio controls><source src="' +
          this.resourceDownloadPath +
          body.url +
          '" type="audio/mpeg"><source src="' +
          this.resourceDownloadPath +
          body.url +
          '" type="audio/ogg">您的浏览器不支持该音频格式。</audio>'
        )
      }
    },
    goBack() {
      this.$store.commit('user/setBlPageIndex', { blPageIndex: 1 })
    },
    hasApp(val) {
      return (
        this.$store.state.user.appList &&
        this.$store.state.user.appList.length > 0 &&
        !!this.$store.state.user.appList.find((item) => item.appId === val)
      )
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/chatlog/history.scss';
  .item-label {
    width: 10px;
  }
</style>
